import Image1 from "../assets/icons/Whatweoffer01.png";
import Image2 from "../assets/icons/Whatweoffer02.png";
import Image3 from "../assets/icons/Whatweoffer03.png";
import Image4 from "../assets/icons/Whatweoffer04.png";
import Image5 from "../assets/icons/Whatweoffer05.png";
import Image6 from "../assets/icons/Whatweoffer06.png";
import Image7 from "../assets/icons/Whatweoffer07.png";
import Image8 from "../assets/icons/Whatweoffer08.png";

export const offeringsData = [
    {
        id: 1,
        icon: Image1,
        title: "Brand & Communication Strategy"
    },
    {
        id: 2,
        icon: Image2,
        title: "Market Entry Strategy"
    },
    {
        id: 3,
        icon: Image3,
        title: "Innovation opportunites"
    },
    {
        id: 4,
        icon: Image4,
        title: "Social Media Analytics"
    },
    {
        id: 5,
        icon: Image5,
        title: "Emerging Trends Identification"
    },
    {
        id: 6,
        icon: Image6,
        title: "Predictive Growth Modelling"
    },
    {
        id: 7,
        icon: Image7,
        title: "Retail Analytics"
    },
    {
        id: 8,
        icon: Image8,
        title: "Go to Market Strategy"
    }
]; 